import { useNavigate, useLocation } from 'react-router-dom';

export default function Layout({ children }) {
  const navigate = useNavigate();
  const location = useLocation();

  const logout = () => {
    localStorage.removeItem('adminKey');
    window.location.href = '/login';
  };

  const navItems = [
    { path: '/dashboard', label: '📊 Дашборд' },
    { path: '/doctors', label: '👨‍⚕️ Врачи' },
    { path: '/patients', label: '🧑 Пациенты' },
    { path: '/clinics', label: '🏥 Клиники' },
    { path: '/networks', label: '🏢 Сети' },
    { path: '/transactions', label: '🧾 Транзакции' },
    { path: '/commissions', label: '💰 Комиссии' },
    { path: '/operation-commissions', label: '🩹 Комиссии операций' },
    { path: '/profile-requests', label: '📝 Заявки профиля' },
    { path: '/notifications', label: '🔔 Уведомления' },
    { path: '/tickets', label: '🎫 Техподдержка' },
    { path: '/documents', label: '📄 Оферта и договоры' },
    { path: '/service-catalog', label: '🩺 Услуги клиник' },
    { path: '/api-log', label: '🔌 API' },
  ];

  return (
    <div style={styles.page}>
      <div style={styles.sidebar}>
        <div style={styles.logo}>Refero<span style={styles.logoAdmin}>admin</span></div>
        <nav style={styles.nav}>
          {navItems.map(item => (
            <div
              key={item.path}
              style={{...styles.navItem, ...((location.pathname === item.path || location.pathname.startsWith(item.path + '/')) ? styles.navItemActive : {})}}
              onClick={() => navigate(item.path)}
            >
              {item.label}
            </div>
          ))}
        </nav>
        <button style={styles.btnLogout} onClick={logout}>Выйти</button>
      </div>
      <div style={styles.content}>{children}</div>
    </div>
  );
}

const styles = {
  page: { display: 'flex', minHeight: '100vh', background: '#0f172a' },
  sidebar: { width: 220, background: '#1e293b', display: 'flex', flexDirection: 'column', padding: '24px 0', flexShrink: 0 },
  logo: { color: '#2EC4B6', fontSize: 22, fontWeight: 700, padding: '0 24px 24px', borderBottom: '1px solid #334155' },
  logoAdmin: { fontSize: 11, color: '#64748b', fontWeight: 400, marginLeft: 6, verticalAlign: 'middle' },
  nav: { display: 'flex', flexDirection: 'column', gap: 4, padding: '16px 12px', flex: 1 },
  navItem: { padding: '10px 12px', borderRadius: 8, color: '#94a3b8', fontSize: 14, cursor: 'pointer' },
  navItemActive: { background: '#0f172a', color: '#2EC4B6', fontWeight: 600 },
  btnLogout: { margin: '0 12px', background: 'transparent', border: '1px solid #334155', color: '#64748b', padding: '8px', borderRadius: 8, cursor: 'pointer', fontSize: 13 },
  content: { flex: 1, padding: 32, overflow: 'auto' },
};